import React from 'react';
/**
 * "Other Suggested TrueScore Products" cross-sell links.
 * Self-contained — link list is owned by this page only.
 */
export function SuggestedProducts() {
  return <div className="text-left w-full mb-12" data-id="element-390">
      <h4 className="font-bold text-gray-900 mb-2" data-id="element-391">
        Other Suggested TrueScore Products
      </h4>
      <ul className="flex flex-col gap-1" data-id="element-392">
        <li data-id="element-393">
          <a href="/shop/daedo-pss-system/" className="text-blue-600 hover:underline" data-id="element-394">
            Gen2 Head Transmitter
          </a>
        </li>
        <li data-id="element-395">
          <a href="/shop/daedo-pss-system/" className="text-blue-600 hover:underline" data-id="element-396">
            Gen2 Receiver
          </a>
        </li>
        <li data-id="element-397">
          <a href="/shop/daedo-pss-system/" className="text-blue-600 hover:underline" data-id="element-398">
            Gen2 E-HeadGear
          </a>
        </li>
      </ul>
    </div>;
}